<template>
  <div class="ReciboComponent">
    <v-card v-if="isNew">
      <v-card-text>
        <v-form @submit.prevent="save()" v-model="isValid">
          <div class="header text-h5 mb-3">Crear nuevo recibo</div>

          <v-textarea
            v-model="recibo.concepto"
            label="Descripción"
            outlined
            dense
            :rules="[rules.requierd]"
          ></v-textarea>
          <v-text-field
            v-model="recibo.total"
            type="number"
            label="Total"
            outlined
            dense
            :rules="[rules.requierd, rules.moreThanZero]"
          />
          <div class="actions-buttons">
            <v-btn @click="isNew = false" outlined small color="primary" depressed
              >Cancelar</v-btn
            >
            <v-btn :disabled="!isValid" type="submit" small color="primary" depressed>Guardar</v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card v-else class="d-flex flex-column">
      <v-card-text class="pb-0">
        <div class="d-flex flex-wrap align-center text-h6 text-md-h5">
          Recibos
          <v-spacer />
          <v-btn @click="isNew = true" small color="primary" depressed dark>Generar recibo</v-btn>
        </div>
      </v-card-text>
      <v-card-text class="flex-grow-1 pt-2">
        <div class="table-scroll">
          <v-simple-table class="recibo-table">
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">Concepto</th>
                  <th class="text-right">Total</th>
                  <th class="text-center">PDF</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td class="text-left">
                    <div class="parrafo" v-html="item.concepto" :title="item.concepto"/>
                  </td>
                  <td class="text-right text-no-wrap">{{ item.total | formatCurrency }}</td>
                  <td class="text-center">
                    <v-btn small icon @click="print(item)">
                      <v-icon color="#d2231a">mdi-file-pdf</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <p v-if="items.length === 0" class="text-center mt-2">
          No hay resultados
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import Receipt from "@/domain/Receipt";
// Tickets
import PrintTicket from "@/helpers/PrintTicket";
export default {
  name: "ReciboComponent",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    isNew: false,
    isValid: false,
    recibo: {},
    rules: {
        requierd: v => !!v || "Este campo es requerido",
        moreThanZero: v => v > 0 || "El valor debe ser mayor a 0"
    }
  }),
  methods: {
    save() {
      Receipt.create(this.recibo)
        .then(() => {
          this.recibo = {};
          this.isNew = false;
          this.$emit("created");
        })
        .catch(err => {
          console.error(err);
        });
    },
    print(receipt) {
      PrintTicket.Receipt(receipt);
    }
  }
};
</script>


<style lang="scss" scoped>
.ReciboComponent {
  height: 100%;

  > .v-card {
    height: 100%;
  }

  .parrafo {
    height: 1rem;
    width: 100%;
    overflow: hidden;
  }
  .actions-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
  .table-scroll {
    max-height: 400px;
    overflow-y: auto;
  }
  .recibo-table ::v-deep {
    tbody tr:nth-child(even) {
      background-color: #f5f5f5;
    }
  }
}
</style>